// const client = ShopifyStorefrontAPIClient.createStorefrontApiClient({
//   storeDomain: Shopify.shop,
//   apiVersion: '2024-10',
//   publicAccessToken: '383153689db97ce2e5ff9b5f617fde1e',
// });


// // cartAttributesUpdate

// const cartAttributesUpdateStr = `
//   mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
//   cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
//     cart {
//       id
//     }
//     userErrors {
//       field
//       message
//     }
//   }
// }
// `;

async function cartAttributesUpdate(attributes, fallback) {
  try {
    const cartData = await Shopify.getCartByPromise();
    if (cartData.item_count !== 0) {
      const formData = new FormData();
      // Convert attributes array to FormData format
      attributes.forEach(attr => {
        formData.append(`attributes[${attr.key}]`, attr.value);
      });

      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      return data;
    } else {
      console.warn('Cart is empty, invoking fallback');
      if (fallback) fallback();
    }
  } catch (error) {
    console.error('Error updating cart attributes:', error.message);
  }
}
